import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import ScheduleIframe from "components/Schedule/ScheduleIframe"
import { getMeetingIframeLink } from "components/Schedule/getIframeLink"

type Props = {
  url: string
  seo: SeoMetadataWithImage
}

export const getStaticProps = async () => {
  // if (!id) {
  //   return {
  //     redirect: {
  //       statusCode: 302,
  //       destination: "/test-drive/3",
  //     },
  //   }
  // }
  // Replace with your code to fetch data
  const url = getMeetingIframeLink(null)
  const seo = {
    title: " קביעת פגישת ייעוץ | מאזדה ישראל - mazda",
    description: "",
    keywords: "",
  }

  return { props: { url, seo } }
}

const TestDrive = ({ url, seo }: Props) => {
  return (
    <>
      <SeoMetaData data={seo} />
      <ScheduleIframe url={url} />
    </>
  )
}

export default TestDrive
